import { render, staticRenderFns } from "./DynamicColumn.vue?vue&type=template&id=61303982"
import script from "./DynamicColumn.vue?vue&type=script&lang=js"
export * from "./DynamicColumn.vue?vue&type=script&lang=js"
import style0 from "./DynamicColumn.vue?vue&type=style&index=0&id=61303982&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports